// extracted by mini-css-extract-plugin
export default {"dropdown-arrow":"DropdownArrow_dropdown-arrow__80OGd","dropdown-arrow__path":"DropdownArrow_dropdown-arrow__path__JR-yV"};